import { Formik } from 'formik';
import React, { useState } from 'react';
import styled from 'styled-components';
import * as Yup from 'yup';
import { Button, Buttons, CancelButton, Field, Form, FormMessage, ModalCard } from '~/components';
import { useApi, useWorkspace } from '~/contexts';
import { useIsMounted } from '~/hooks';

const Description = styled.p`
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

const BambooDomain = styled.div`
  display: flex;
  align-items: center;

  > div {
    flex: 1;
  }
`;

export default function BambooSetup({ onClose }) {
  const api = useApi();
  const isMounted = useIsMounted();
  const { workspace } = useWorkspace();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const initialValues = {
    domain: '',
  };

  async function handleSubmit(values) {
    setIsLoading(true);
    setErrorMessage();

    try {
      const { data } = await api.www.workspaces(workspace.id).bamboohr.authorize(values);

      if (data.authorizeUri) {
        window.location.href = data.authorizeUri;
      }
    } catch ({ message }) {
      if (message) {
        setErrorMessage(message);
      } else {
        setErrorMessage('There was a problem completing your request. Please try again later.');
      }
    } finally {
      if (isMounted.current) {
        setIsLoading(false);
      }
    }
  }

  return (
    <ModalCard title="Setup BambooHR Integration" onClose={onClose}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={Yup.object().shape({
          domain: Yup.string().label('Domain').max(255).required(),
        })}>
        {() => {
          return (
            <Form>
              <ModalCard.Body>
                <Description>To setup an integration with BambooHR, enter your BambooHR Domain.</Description>
                <Form.Control>
                  <BambooDomain>
                    <Field.Text name="domain" placeholder="companydomain" maxLength={255} />
                    .bamboohr.com
                  </BambooDomain>
                </Form.Control>
                {errorMessage && <FormMessage.Error>{errorMessage}</FormMessage.Error>}
              </ModalCard.Body>
              <ModalCard.Footer>
                <Buttons align="right">
                  <CancelButton onClick={onClose} style={{ marginRight: 'auto' }}>
                    Close
                  </CancelButton>
                  <Button type="submit" isLoading={isLoading}>
                    Install
                  </Button>
                </Buttons>
              </ModalCard.Footer>
            </Form>
          );
        }}
      </Formik>
    </ModalCard>
  );
}
